import React from 'react';
import {connect} from 'react-redux';
import newId from '../../utils/NewId';
import {rateMeditation} from '../../actions/Meditation';
import {ShareButtons} from 'react-share';
import config from '../../config';

const {FacebookShareButton} = ShareButtons;

const starsCount = 5;

class FeedbackPopup extends React.Component {
    constructor(props) {
        super(props);

        let highlight = {};

        for (let i = 1; i <= starsCount; i++) {
            this[`highlight${i}`] = this.highlight.bind(this, i);
            this[`saveRating${i}`] = this.saveRating.bind(this, i);
            highlight[i] = false;
        }

        this.state = {
            highlight,
            rated: 0
        };
    }

    saveRating(rating) {
        this.setState({rated: rating}, () => {
            this.highlight(rating);
        });

        this.dispatchRateMeditation(this.props.data.id, rating);
    }

    dispatchRateMeditation(id, rating) {
        this.props.dispatch(rateMeditation(this.dispatchRateMeditation.bind(this, id, rating), {
            id: id,
            rating: rating
        }));
    }

    highlight(index) {
        let newHighlight = {};
        for (let i = 1; i <= starsCount; i++) {
            newHighlight[i] = (i <= this.state.rated);
        }

        let newState = Object.assign({}, this.state, {
            highlight: newHighlight
        });

        for (let i = 1; i <= index; i++) {
            newHighlight[i] = true;
        }

        this.setState(newState);
    }

    render() {
        const stars = [];
        for (let i = 1; i <= starsCount; i++) {
            stars.push(<div key={newId('star')}
                            className={"star" + (this.state.highlight[i] || this.state.rated[i] ? " active" : "")}
                            onClick={this[`saveRating${i}`]} onMouseEnter={this[`highlight${i}`]}/>);
        }

        return <div>
            <h3 className="text-center">Как бихте оценили тази медитация?</h3>
            <div className="rating-stars">
                {stars.map(star => star)}
            </div>
            <p>Споделете своя опит във Facebook, за да могат повече хора да се докоснат до магията на
                медитацията.</p>
            <FacebookShareButton
                url={config.baseUrl}
                quote={`Аз изпълних ден ${this.props.data.completedMeditation} от безплатната програма за водени медитации "${this.props.data.packTitle}"`}
                className="btn btn-default share-btn"
            >Сподели</FacebookShareButton>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.popup.popupData
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackPopup);


// WEBPACK FOOTER //
// ./src/components/Popups/FeedbackPopup.js